import { Component, Input } from '@angular/core';
import { EntityArt } from '@enums/entityArt.enum';


@Component({
    selector: 'cz-bemerkungen-popup',
    templateUrl: 'bemerkungen-popup.component.html',
    styleUrls: ['./bemerkungen-popup.component.css'],
    standalone: false
})
export class BemerkungenPopupComponent {

    popupVisible: boolean;

    @Input() ownerId: number;
    @Input() entityArt: EntityArt;

    loading = false;

    constructor() {
        this.hidePopup = this.hidePopup.bind(this);
    }

    showPopup() {
        this.popupVisible = true;
    }

    hidePopup() {
        this.popupVisible = false;
    }
}
